export const isLocalEnv = () => {
    return process.env.NODE_ENV === "development";
};
